export default function AdminBehaviorEditExamples() {
  return <div className="">examples</div>;
}
